// Slice a tall page-image into overlapping, legible tiles for a vision model.
// Shared by the document importer and the drill importer.
//
// Why: vision models squash a single 500×4000 strip until the text is
// unreadable (which is what made one ramble 15k chars and extract nothing);
// ~page-sized tiles OCR far better. Short images pass through as one tile.

const loadImage = (file) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file)
  const img = new Image()
  img.onload = () => resolve(img)
  img.onerror = (e) => { URL.revokeObjectURL(url); reject(e) }
  img.src = url
})

// → array of base64 JPEGs (no data: prefix), ready for Ollama's `images`.
export async function imageToTiles(file) {
  let img
  try { img = await loadImage(file) } catch { return [] }
  const url = img.src
  const w = img.naturalWidth || img.width
  const h = img.naturalHeight || img.height
  const maxW = 1200
  const scale = w > maxW ? maxW / w : 1
  const sw = Math.round(w * scale)
  const enc = (c) => c.toDataURL('image/jpeg', 0.85).split(',')[1]
  const draw = (srcY, srcH) => {
    const c = document.createElement('canvas')
    c.width = sw
    c.height = Math.round(srcH * scale)
    c.getContext('2d').drawImage(img, 0, srcY, w, srcH, 0, 0, sw, c.height)
    return enc(c)
  }
  const TILE = 1100   // rendered tile height
  const OVERLAP = 150 // so a line split across a boundary survives in one tile
  try {
    if (h * scale <= TILE * 1.4) return [draw(0, h)]
    const tiles = []
    const stepSrc = (TILE - OVERLAP) / scale
    const tileSrcH = TILE / scale
    for (let y = 0; y < h; y += stepSrc) {
      const srcH = Math.min(tileSrcH, h - y)
      tiles.push(draw(y, srcH))
      if (y + srcH >= h) break
    }
    return tiles
  } finally {
    URL.revokeObjectURL(url)
  }
}

export default imageToTiles
